import { defineNuxtPlugin } from '#app'
import Treeselect from "@zanmato/vue3-treeselect";
import "@zanmato/vue3-treeselect/dist/vue3-treeselect.min.css";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('Treeselect', Treeselect)
})
